import { ServiceAgreementState } from '@levelworks/shared-domain-types';
import { assertUnreachable } from '@levelworks/shared-utils-ts';

export const getServiceAgreementStateLabel = (
  state: ServiceAgreementState
): {
  key: string;
  ns: string;
} => {
  switch (state) {
    case ServiceAgreementState.ACCEPTED:
      // t('service_agreement.state.accepted', { ns: 'all-platforms-common' })
      return { key: 'service_agreement.state.accepted', ns: 'all-platforms-common' };
    case ServiceAgreementState.REJECTED:
      // t('service_agreement.state.rejected', { ns: 'all-platforms-common' })
      return { key: 'service_agreement.state.rejected', ns: 'all-platforms-common' };
    case ServiceAgreementState.PENDING:
      // t('service_agreement.state.pending', { ns: 'all-platforms-common' })
      return { key: 'service_agreement.state.pending', ns: 'all-platforms-common' };
    case ServiceAgreementState.TERMINATED:
      // t('service_agreement.state.terminated', { ns: 'all-platforms-common' })
      return { key: 'service_agreement.state.terminated', ns: 'all-platforms-common' };
    default:
      assertUnreachable(state);
  }
};
